import React, { useMemo, useState } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { useTheme } from '../theme';
import { validateBase64 } from '../lib/validate';

export default function Base64Validator() {
  const { darkMode, themeClasses } = useTheme();
  const [input, setInput] = useState('');

  const result = useMemo(() => (input.trim() ? validateBase64(input) : null), [input]);

  return (
    <div className={`${themeClasses.cardBg} rounded-3xl border p-5 sm:p-8 space-y-6`}>
      <div>
        <label className={`block text-lg font-semibold mb-3 ${themeClasses.textPrimary}`}>
          Paste a Base64 string to validate
        </label>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Paste a Base64 string here..."
          aria-label="Base64 string to validate"
          className={`w-full h-40 p-4 ${themeClasses.inputBg} border rounded-2xl resize-none break-all`}
        />
      </div>

      {result && (
        <div
          className={`flex items-start gap-3 p-4 rounded-2xl border ${
            result.valid
              ? darkMode ? 'bg-green-500/10 border-green-500/30' : 'bg-green-50 border-green-200'
              : themeClasses.errorBg
          }`}
        >
          {result.valid ? (
            <CheckCircle2 className={`w-5 h-5 shrink-0 ${darkMode ? 'text-green-400' : 'text-green-600'}`} />
          ) : (
            <XCircle className="w-5 h-5 shrink-0" />
          )}
          <span className={result.valid ? `${darkMode ? 'text-green-300' : 'text-green-800'} font-medium` : 'font-medium'}>
            {result.reason}
          </span>
        </div>
      )}
    </div>
  );
}
